import { render, staticRenderFns } from "./TakipBilgileriForm.vue?vue&type=template&id=cd241f9e&scoped=true"
import script from "./TakipBilgileriForm.vue?vue&type=script&lang=ts"
export * from "./TakipBilgileriForm.vue?vue&type=script&lang=ts"
import style0 from "./TakipBilgileriForm.vue?vue&type=style&index=0&id=cd241f9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd241f9e",
  null
  
)

export default component.exports